<ng-container
  *ngIf="(selectedProductGroups$ | async) as selectedProductGroups; else loader"
>
  <prlw-group-product-filter-ui
    [selectedProductGroups]="selectedProductGroups"
    [currentProductGroup]="currentProductGroup$ | async"
    [isEveryProductGroupSelected]="(isEveryProductGroupSelected$ | async) || false"
    [isAllSelected]="isAllSelected"
    [isOverlay]="false"
    [isOverflow]="isOverflow$ | async"
    [isOverflowLeft]="isOverflowLeft$ | async"
    [isOverflowRight]="isOverflowRight$ | async"
    [doesCurrentGroupHaveProducts]="doesCurrentGroupHaveProducts$ | async"
    (toggleOverlay)="openOverlay()"
    (toggleMobileOverlay)="handleToggleMobileOverlay()"
    (initResizeObserver)="setInit($event)"
    (openProductSelectionDialog)="openSelectionDialog()"
    (updateOverflow)="updateOverflow($event)"
  ></prlw-group-product-filter-ui>
</ng-container>

<ng-template #loader>
  <prlw-product-loader-ui [plugsLength]="13"></prlw-product-loader-ui>
</ng-template>
